import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { METHOD_TYPES } from 'constants/index'

const BALLOON_PUMP_API_PREFIX = '/game/fast-game/balloon-pump-game'
const balloonConfig = { server: microServices.SERVICE_URL_1 }

const balloonRequest = (method, endpoint, data = {}, config = {}) =>
  axiosInstanceService(method, `${BALLOON_PUMP_API_PREFIX}/${endpoint}`, data, {
    ...balloonConfig,
    ...config
  })

export const getMyBetsService = (params) =>
  balloonRequest(METHOD_TYPES.get, 'my-bets', {}, { params })

export const getTopBetsService = (params) =>
  balloonRequest(METHOD_TYPES.get, 'get-top-win', {}, { params })
